import Base, { ShippingState } from 'core/pages/Shipping/ShippingReading'
import { ShippingParcel } from 'stylewhere/api'
import { KeyValueRow, RemoveMode, Stoplight } from 'stylewhere/components'
import { __ } from 'stylewhere/i18n'
import { OperationReadingProps, Router } from 'stylewhere/shared'
import { hasAsyncConfirm, showToast } from 'stylewhere/utils'
import { downloadParcelLabelPdf } from './parcelLabel'
import { ProductionOrderCandidate } from './productionOrder'

interface OtbShippingState extends ShippingState {
  resolvedProductionOrder?: ProductionOrderCandidate
}

export default class ShippingReading extends Base<OperationReadingProps<ShippingState>, ShippingState> {
  get locationState() {
    return Router.getLocationState<OtbShippingState>(this.props)
  }

  get productionOrderRowId(): string | undefined {
    return this.locationState?.resolvedProductionOrder?.id
  }

  componentDidMount() {
    const parcel = this.locationState?.parcel
    console.log('[OTB-DEBUG] reading parcel from startParcel', {
      productionOrderRowId: this.productionOrderRowId,
      parcelId: parcel?.id,
      parcelCode: parcel?.code,
      checklistType: parcel?.checklist?.type,
      checklistCode: parcel?.checklist?.code,
      checklistSource: parcel?.checklist?.attributes?.checklistSource,
      checklistProducts: parcel?.checklist?.checklistProducts?.map(({ productCode, quantity, detected }) => ({
        productCode,
        quantity,
        detected
      })),
      products: Object.keys(parcel?.products ?? {})
    })
    super.componentDidMount()
  }

  getExtraConfirmAttributes(): Record<string, any> {
    return this.productionOrderRowId ? { productionOrderRowId: this.productionOrderRowId } : {}
  }

  getExtraDecodeAttributes(): Record<string, any> {
    return this.productionOrderRowId ? { productionOrderRowId: this.productionOrderRowId } : {}
  }

  renderHeaderRight = (sseStatus: boolean, tagCounterDetected: number) => {
    const code = this.locationState?.resolvedProductionOrder?.productionOrder?.code
    return (
      <>
        {code && (
          <KeyValueRow
            variant="raw"
            label={__('otb_outbound.header_label')}
            value={code}
            style={{ paddingLeft: 0, paddingRight: 15 }}
          />
        )}
        {hasAsyncConfirm(this.operation) ? <Stoplight active={sseStatus} /> : undefined}
        {this.operationRemoveModeAllowed && tagCounterDetected > 0 && (
          <RemoveMode onRemoveChange={this.onRemoveChange} />
        )}
      </>
    )
  }

  isChecklistDisplayEnabled(): boolean {
    return !!this.state.parcel?.checklist
  }

  async afterConfirmParcel(confirmedParcel?: ShippingParcel): Promise<void> {
    console.log('[OTB-DEBUG] confirmed parcel', {
      productionOrderRowId: this.productionOrderRowId,
      parcelId: confirmedParcel?.id,
      parcelCode: confirmedParcel?.code,
      attributes: confirmedParcel?.attributes
    })
    if (!this.productionOrderRowId) return
    const title = __('otb_outbound.pdf_title')
    if (!confirmedParcel?.id) {
      showToast({ status: 'warning', sound: true, title, description: __('otb_outbound.pdf_parcel_unavailable') })
      return
    }
    try {
      await downloadParcelLabelPdf(this.operation, confirmedParcel, this.productionOrderRowId)
      showToast({ status: 'success', sound: false, title, description: __('otb_outbound.pdf_downloaded') })
    } catch {
      showToast({ status: 'error', sound: true, title, description: __('otb_outbound.pdf_error') })
    }
  }
}
